import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { fetchCategories } from "../api/categoryApi";
import { useTranslation } from "react-i18next";
import config from "../config";
import bgImage from "../assets/bg2.png";
import perfume from "../assets/b2.png";
import Delire from "../components/Delire";
import FeaturedProducts from "../components/FeaturedProducts";



const Home = () => {
  const { t, i18n } = useTranslation();
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    async function getcategorys() {
      const data = await fetchCategories({}); // Fetch category list

      setCategories(data);
    }
    getcategorys();
  }, []);
  return (
    <div className=" w-full ">
      {/* Hero Section */}
      <section
        style={{ backgroundImage: `url(${bgImage})` }}
        className="relative py-16 mt-0 bg-cover  "
      >
        <div className="container mx-auto px-4 grid md:grid-cols-2 items-center gap-8">
          <div className="space-y-6">
            <div className="flex flex-col items-center text-center  space-y-4">
              <h1 className="text-lg md:text-2xl sm:text-sm font-bold text-white">
                {t('welcome')}
              </h1>
              <Delire
                fillColor="text-white"
                width="h-24 md:h-12 sm:h-10 max-[320px]:h-10"
              />
              <h2 className="text-3xl md:text-2xl font-thin text-white">
                PERFUME
              </h2>
            </div>

            <div className=" w-full p-5 text-wrap text-2xl text-white ">
              {i18n.language === "ar"
                ? "اكتشف عالمًا من الروائح الآسرة التي تحدد الأناقة والفخامة والقوة."
                :(
                  <> 
                    Discover a world of captivating scents that define <strong>elegance</strong>, <strong>luxury</strong>, and  <strong>power</strong>  </> )}
            </div>

            <Link
              to="/products/all"
              className="inline-flex items-center bg-green-800 text-white px-6 py-3 rounded-lg hover:bg-green-600 transition"
            >
              {t("ShopNow")} <ChevronRight className="ml-2" />
            </Link>
          </div>
          <div>
            <img src={perfume} alt="Hero Product" className="w-[40%] " />
          </div>
        </div>
      </section>

      <FeaturedProducts />
      {/* Top Categories Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-10">
            {t("TopCategories")}
          </h2>
          <div className="grid md:grid-cols-3 gap-6 justify-center w-full items-center">
            {categories.map((category) => (
              <Link
                key={category.category_id}
                to={`/products/${category.en_name}?id=${category.category_id}`}
                className="group relative overflow-hidden rounded-xl shadow-lg"
              >
                <img
                  src={`${config.apiUrl}/assets/uploads/${category.photo}`}
                  alt={`perfume category of ${category.en_name}`}
                  className="w-full h-64 object-cover transition-transform duration-300 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center">
                  <span className="text-white text-2xl font-bold">
                    {i18n.dir() === "rtl"
                      ? category.ar_name
                      : category.en_name?.toUpperCase()}
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
